import { useTranslation } from "@shared/utils/internationalization";
import Alert from "@ui-kit/feedback/alerts/Alert/Alert.web";
import Box from "@ui-kit/layout/Box/Box.web";
import { AllowedShippingWarningProps } from "./AllowedShippingWarning.props";

function formatCountryList(countries: string[], locale = "en") {
  return new Intl.ListFormat(locale, {
    style: "long",
    type: "conjunction", // "A, B, and C"
  }).format(countries);
}

export default function AllowedShippingWarning({
  allowedCountries,
}: AllowedShippingWarningProps): JSX.Element {
  const { t, i18n } = useTranslation("checkout");

  return (
    <Alert status="warning" alignItems="flex-start" showBorder>
      <Alert.Icon marginTop="2xs" />
      <Box>
        <Alert.Title>{t("Shipping restriction")}</Alert.Title>
        <Alert.Description>
          {t(
            "We currently ship only to addresses within {{count}} {{countries}}. Please select a delivery method other than shipping if your country is not available.",
            {
              countries: formatCountryList(allowedCountries, i18n.language),
              count: allowedCountries.length,
            }
          )}
        </Alert.Description>
      </Box>
    </Alert>
  );
}
